import { ModelBase } from './ModelBase';

const SERIALIZE = ['_currentStage'];
export class StoryModel extends ModelBase {
  constructor(data) {
    super('StoryModel', { colour: 'limegreen', serialize: SERIALIZE });

    this._stages = data.levels.reduce((arr, level, lvlindex) => {
      level.stages.forEach((stage, index) => {
        arr.push({
          id: stage.id,
          levelid: level.id,
          levelindex: lvlindex + 1,
          endlevel: index === level.stages.length - 1,
          cutscene: index === level.stages.length - 1 ? level.cutsceneEnd || false : false,
        });
      });
      return arr;
    }, []);

    this.log('story model added');

    // this._stageResults = {};
    this._currentStage = 0;
  }

  isComplete() {
    return this._currentStage >= this._stages.length;
  }

  isFinalStage() {
    return this._currentStage == this._stages.length;
  }

  getCurrentLevel() {
    return this._stages[this._currentStage].levelid;
  }

  getNextLevelIndex() {
    return this._stages[this._currentStage + 1]?.levelindex;
  }

  getCurrentStageId() {
    return this._stages[this._currentStage].id;
  }

  hasProgress() {
    return this._currentStage > 0;
  }

  completeCurrentLevelStage(results) {
    const currentStage = this._stages[this._currentStage];
    const completesLevel = currentStage.endlevel;
    // this._stageResults[currentStage.id] = results;
    this._currentStage++;
    return completesLevel ? { cutsceneEnd: currentStage.cutscene || false } : false;
  }

  forceCompleteStory() {
    this._currentStage = this._stages.length;
  }

  jumpToStage(stageid) {
    this._currentStage = this._stages.findIndex((s) => s.id == stageid);
  }
}

// =============================================================================================
// LEVEL MODEL
// =============================================================================================

// class StoryLevelModel extends ModelBase {
//   constructor(data) {
//     super('Story Level ' + data.id, {
//       colour: 'lightgreen',
//       serialize: ['_id', '_stages'],
//     });
//     this._id = data.id;
//     this.log('added : stages [ ' + data.stages.toString() + ' ]');
//     this._stages = data.stages.map((l) => new StoryStageModel({ id: l }));
//     this._cutsceneEnd = data.cutsceneEnd;
//   }

//   get cutsceneEnd() {
//     return this._cutsceneEnd;
//   }

//   get id() {
//     return this._id;
//   }

//   jumpToStage(stageid) {
//     for (let i = 0; i < this._stages.length; i++) {
//       if (this._stages[i].id === stageid) {
//         break;
//       } else {
//         this._stages[i]._complete = true;
//       }
//     }
//   }

//   hasStageId(stageid) {
//     return this._stages.find((s) => s.id === stageid) ? true : false;
//   }

//   forceComplete() {
//     this._stages.forEach((s) => (s._complete = true));
//   }

//   isComplete() {
//     return this._stages.find((s) => !s.isComplete()) ? false : true;
//   }

//   completeCurrentStage(results) {
//     const stage = this._stages.find((s) => !s.isComplete());
//     stage.completeStage(results);

//     if (this.isComplete()) {
//       this.log('complete', this.getLevelResults());
//       return true;
//     }
//     return false;
//   }

//   getCurrentStage() {
//     const next = this._stages.find((s) => !s.isComplete());
//     return next.id || false;
//   }

//   getProgress() {
//     const complete = this._stages.reduce((i, s) => (s.isComplete() ? i + 1 : i), 0);
//     return complete / this._stages.length;
//   }

//   getLevelResults() {
//     return this._stages.reduce(
//       (r, stage) => {
//         const stageScore = stage.getScoreSummary();
//         r.coins += stageScore.coins;
//         r.time += stageScore.time;
//         r.lives += stageScore.lives;
//         r.damage += stageScore.damage;
//         r.score += stageScore.score;
//         return r;
//       },
//       { coins: 0, time: 0, lives: 0, damage: 0, score: 0 }
//     );
//   }

//   serialize() {
//     return {
//       _id: this._id,
//       _stages: this._stages.map((s) => s.serialize()),
//     };
//   }

//   deserialize(data) {
//     data._stages.forEach((s) => {
//       // const stage = new StoryStageModel()
//       const stage = this._stage.find((stage) => stage.id === s._id);
//       if (stage) stage.deserialize(s);
//     });
//   }
// }

// // =============================================================================================
// // STAGE MODEL
// // =============================================================================================

// class StoryStageModel extends ModelBase {
//   constructor(data) {
//     super('Story Stage ' + data.id, {
//       colour: 'yellowgreen',
//       serialize: ['_id', '_complete', '_stageResults'],
//     });
//     this.log('added');
//     this._id = data.id;
//     this._complete = false;
//     this._stageResults = false;
//   }

//   get id() {
//     return this._id;
//   }

//   isComplete() {
//     return this._complete || false;
//   }

//   getScoreSummary() {
//     return this._stageResults ? { ...this._stageResults.scoreSummary } : false;
//   }

//   getStageResults() {
//     return this._stageResults || false;
//   }

//   completeStage(results) {
//     const summary = { ...results };
//     summary.score = Object.values(summary).reduce((i, s) => i + s, 0);
//     this._complete = true;
//     this._stageResults = { summary };
//     this.log('complete', this._complete);
//   }

//   serialize() {
//     return { _id: this._id, _complete: this.complete, _stageResults: this._stageResults };
//   }
// }
